// extracted by mini-css-extract-plugin
export default {"installation-costs":"installation-costs-message__installation-costs___1mlK4"};